import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, NoPreloading, RouterModule } from '@angular/router';
import { FuseModule } from '../@fuse';
import { FuseConfigModule } from '../@fuse/services/config';
import { FuseMockApiModule } from '../@fuse/lib/mock-api';
import { CoreModule } from './core/core.module';
import { appConfig } from './core/config/app.config';
import { mockApiServices } from './mock-api';
import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import { UserAddQuickComponent } from './modals/user-add-quick/user-add-quick.component';
import { UserModule } from './modules/users/users.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorCustom } from './modules/shared/components/mat-paginator-custom/matPaginatorCustom';
import { ErrorLoggerService } from './core/services/error-logger.service';

const routerConfig: ExtraOptions = {
    preloadingStrategy       : NoPreloading,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule

    ],
    exports: [

    ],
    bootstrap   : [
        AppComponent
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: MatPaginatorCustom},
        { provide: ErrorHandler, useClass: ErrorLoggerService },
        ErrorLoggerService
    ]
})
export class AppModule
{
}
